import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, mergeMap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import {
  GlobalDocumentsActions,
  GetAllGlobalDocuments,
  CloneToCompany,
  AddGlobalDocument,
  GetGlobalDocumentTypes,
  EditGlobalDocument,
  DeleteGlobalDocument,
} from '../actions/globalDocuments.action';
import { GlobalDocumentsService } from 'src/app/Services/GlobalDocuments/global-documents.service';

@Injectable()
export class GlobalDocumentsEffects {
  constructor(
    private actions$: Actions,
    private globalDocumentsService: GlobalDocumentsService
  ) {}

  getAllGlobalDocuments$ = createEffect(() =>
    this.actions$.pipe(
      ofType<GetAllGlobalDocuments>(GlobalDocumentsActions.GetAllGlobalDocuments),
      mergeMap(() =>
        this.globalDocumentsService.getAllGlobalDocuments().pipe(
          map((result: any) => ({
            type: GlobalDocumentsActions.GetAllGlobalDocumentsSuccess,
            payload: result,
          })),
          catchError((err) =>
            of({
              type: GlobalDocumentsActions.GetAllGlobalDocumentsError,
              payload: err,
            })
          )
        )
      )
    )
  );

  cloneToCompany$ = createEffect(() =>
    this.actions$.pipe(
      ofType<CloneToCompany>(GlobalDocumentsActions.CloneToCompany),
      mergeMap((action) =>
        this.globalDocumentsService.cloneToCompany(action.payload).pipe(
          map((result: any) => ({
            type: GlobalDocumentsActions.CloneToCompanySuccess,
            payload: result,
          })),
          catchError((err) =>
            of({
              type: GlobalDocumentsActions.CloneToCompanyError,
              payload: err,
            })
          )
        )
      )
    )
  );

  addGlobalDocument$ = createEffect(() =>
    this.actions$.pipe(
      ofType<AddGlobalDocument>(GlobalDocumentsActions.AddGlobalDocument),
      mergeMap((action) =>
        this.globalDocumentsService.addGlobalDocument(action.payload).pipe(
          map((result: any) => ({
            type: GlobalDocumentsActions.AddGlobalDocumentSuccess,
            payload: result,
          })),
          catchError((err) =>
            of({
              type: GlobalDocumentsActions.AddGlobalDocumentError,
              payload: err,
            })
          )
        )
      )
    )
  );

  getDocumentTypes$ = createEffect(() =>
    this.actions$.pipe(
      ofType<GetGlobalDocumentTypes>(GlobalDocumentsActions.GetGlobalDocumentTypes),
      mergeMap(() =>
        this.globalDocumentsService.getDocumentTypes().pipe(
          map((result: any) => ({
            type: GlobalDocumentsActions.GetGlobalDocumentTypesSuccess,
            payload: result,
          })),
          catchError((err) =>
            of({
              type: GlobalDocumentsActions.GetGlobalDocumentTypesError,
              payload: err,
            })
          )
        )
      )
    )
  );

  editGlobalDocument$ = createEffect(() =>
    this.actions$.pipe(
      ofType<EditGlobalDocument>(GlobalDocumentsActions.EditGlobalDocument),
      mergeMap((action) => {
        const { id, ...body } = action.payload;
        return this.globalDocumentsService.editGlobalDocument(id, body).pipe(
          map((result: any) => ({
            type: GlobalDocumentsActions.EditGlobalDocumentSuccess,
            payload: result,
          })),
          catchError((err) =>
            of({
              type: GlobalDocumentsActions.EditGlobalDocumentError,
              payload: err,
            })
          )
        );
      })
    )
  );

  deleteGlobalDocument$ = createEffect(() =>
    this.actions$.pipe(
      ofType<DeleteGlobalDocument>(GlobalDocumentsActions.DeleteGlobalDocument),
      mergeMap((action) =>
        this.globalDocumentsService.deleteGlobalDocument(action.payload.id).pipe(
          map((result: any) => ({
            type: GlobalDocumentsActions.DeleteGlobalDocumentSuccess,
            payload: result,
          })),
          catchError((err) =>
            of({
              type: GlobalDocumentsActions.DeleteGlobalDocumentError,
              payload: err,
            })
          )
        )
      )
    )
  );
}
